import type { Contact, ContactInfoInput, ContactInput, NameInput } from 'sr-types/lib/shortlist/v1/graphql';

const toNameInput = (name: Contact['name']): NameInput | undefined => {
    if (!name) {
        return undefined;
    }

    return {
        firstName: name.firstName ?? '',
        lastName: name.lastName ?? '',
        salutation: name.salutation,
        suffix: name.suffix
    };
};

const toContactInfoInput = (contactInfo: Contact['contactInfo']): ContactInfoInput | undefined => {
    if (!contactInfo) {
        return undefined;
    }

    return {
        email: contactInfo.email
            ? {
                  address: contactInfo.email.address ?? '',
                  typeString: contactInfo.email.typeString ?? '',
                  verified: contactInfo.email.verified ?? false
              }
            : undefined,
        phone: contactInfo.phone
            ? {
                  number: contactInfo.phone.number ?? '',
                  typeString: contactInfo.phone.typeString ?? ''
              }
            : undefined
    };
};

/** Strips display-only image fields (`profileImage`, `profileImageReference`) that ContactInput does not define. */
export const stripProfileImageFromContacts = (contacts: ContactInput[] | undefined): ContactInput[] => {
    if (!contacts) return [];
    return contacts.map((contact) => {
        const { profileImage, profileImageReference, ...rest } = contact as Record<string, unknown>;
        return rest as ContactInput;
    });
};

export const normalizedRepresentatives =(representatives: Contact[]): ContactInput[] =>
    (representatives ?? []).map((representative: Contact) => {
        const representativeInput: ContactInput = {
            name: toNameInput(representative.name),
            role: representative.role,
            contactInfo: toContactInfoInput(representative.contactInfo),
            personReference: representative.personReference,
            organization: representative.organization,
            organizationReference: representative.organizationReference,
            isPrimary: representative.isPrimary
        };

        return representativeInput;
    });
